/* AVARAÉ RITUAL — theme.js (vanilla, no dependencies) */
(function () {
  'use strict';

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  /* ---------- Cart state ---------- */

  async function cartRequest(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error('Cart request failed: ' + res.status);
    return res.json();
  }

  async function refreshCartDrawer(openAfter) {
    try {
      const res = await fetch(window.location.pathname + '?sections=cart-drawer');
      const data = await res.json();
      const html = data['cart-drawer'];
      if (!html) return;
      const wrap = document.createElement('div');
      wrap.innerHTML = html;
      const fresh = $('[data-cart-drawer]', wrap);
      const current = $('[data-cart-drawer]');
      if (fresh && current) {
        const wasOpen = current.classList.contains('is-open');
        current.replaceWith(fresh);
        bindCartDrawer(fresh);
        if (wasOpen || openAfter) openDrawer(fresh);
      }
      const countEl = fresh && $('[data-cart-count-inline]', fresh);
      if (countEl) {
        const count = (countEl.textContent.match(/\d+/) || ['0'])[0];
        $$('[data-cart-count]').forEach((el) => {
          el.textContent = count;
          el.classList.toggle('is-empty', count === '0');
        });
      }
    } catch (e) { console.error(e); }
  }

  async function addToCart(variantId, quantity) {
    await cartRequest(window.theme.routes.cartAdd + '.js', {
      items: [{ id: Number(variantId), quantity: quantity || 1 }]
    });
    await refreshCartDrawer(true);
  }

  async function changeLine(line, quantity) {
    await cartRequest(window.theme.routes.cartChange + '.js', { line: line, quantity: quantity });
    await refreshCartDrawer(false);
  }

  /* ---------- Drawer open/close ---------- */

  function openDrawer(drawer) {
    drawer = drawer || $('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer(drawer) {
    drawer = drawer || $('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function bindCartDrawer(drawer) {
    $$('[data-cart-close]', drawer).forEach((el) =>
      el.addEventListener('click', () => closeDrawer(drawer))
    );

    // Shuffle upsell recommendations so every visit sees a different mix
    const upsellScroller = $('.cart-upsell__scroller', drawer);
    if (upsellScroller) {
      const cards = Array.from(upsellScroller.children);
      for (let i = cards.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [cards[i], cards[j]] = [cards[j], cards[i]];
      }
      cards.forEach((card) => upsellScroller.appendChild(card));
    }

    $$('.cart-item', drawer).forEach((item) => {
      const line = Number(item.dataset.line);
      if (!line) return;
      const input = $('[data-qty-input]', item);

      $$('[data-qty-change]', item).forEach((btn) =>
        btn.addEventListener('click', () => {
          const next = Math.max(0, Number(input.value) + Number(btn.dataset.qtyChange));
          changeLine(line, next);
        })
      );
      if (input) {
        input.addEventListener('change', () => changeLine(line, Math.max(0, Number(input.value))));
      }
      const removeBtn = $('[data-remove]', item);
      if (removeBtn) removeBtn.addEventListener('click', () => changeLine(line, 0));
    });

    $$('[data-upsell-add]', drawer).forEach((btn) =>
      btn.addEventListener('click', async () => {
        btn.disabled = true;
        try { await addToCart(btn.dataset.upsellAdd, 1); } finally { btn.disabled = false; }
      })
    );
  }

  /* ---------- Global click bindings ---------- */

  document.addEventListener('click', async (e) => {
    const openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); openDrawer(); return; }

    const quickAdd = e.target.closest('[data-quick-add]');
    if (quickAdd && !quickAdd.closest('[data-cart-drawer]')) {
      e.preventDefault();
      const original = quickAdd.textContent;
      quickAdd.disabled = true;
      try {
        await addToCart(quickAdd.dataset.quickAdd, 1);
        quickAdd.textContent = window.theme.strings.addedToCart;
        quickAdd.classList.add('is-added');
        setTimeout(() => {
          quickAdd.textContent = original;
          quickAdd.classList.remove('is-added');
        }, 2000);
      } catch (err) { console.error(err); }
      quickAdd.disabled = false;
      return;
    }

    const upsell = e.target.closest('[data-upsell-add]');
    if (upsell && !upsell.closest('[data-cart-drawer]')) {
      e.preventDefault();
      upsell.disabled = true;
      try { await addToCart(upsell.dataset.upsellAdd, 1); } finally { upsell.disabled = false; }
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeDrawer();
      closeMobileNav();
      closePopup();
    }
  });

  /* ---------- Product form (PDP) ---------- */

  function bindProductForm() {
    const form = $('form[data-product-form]');
    if (!form) return;
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = $('[data-atc]', form);
      const variantId = $('[data-variant-id]', form).value;
      const qtyInput = $('input[name="quantity"]', form);
      const qty = qtyInput ? Math.max(1, Number(qtyInput.value)) : 1;
      const original = btn.textContent.trim();
      btn.disabled = true;
      try {
        await addToCart(variantId, qty);
        btn.textContent = window.theme.strings.addedToCart;
        btn.classList.add('is-added');
        setTimeout(() => {
          btn.textContent = original;
          btn.classList.remove('is-added');
        }, 2000);
      } catch (err) { console.error(err); }
      btn.disabled = false;
    });

    $$('[data-qty]', form.closest('.pdp__info') || document).forEach((qtyEl) => {
      const input = $('[data-qty-input]', qtyEl);
      $$('[data-qty-change]', qtyEl).forEach((btn) =>
        btn.addEventListener('click', () => {
          input.value = Math.max(Number(input.min) || 1, Number(input.value) + Number(btn.dataset.qtyChange));
        })
      );
    });
  }

  /* ---------- PDP gallery ---------- */

  function bindGallery() {
    const gallery = $('[data-gallery]');
    if (!gallery) return;
    const medias = $$('[data-media-index]', gallery);
    $$('[data-thumb-index]', gallery).forEach((thumb) =>
      thumb.addEventListener('click', () => {
        const i = thumb.dataset.thumbIndex;
        medias.forEach((m) => m.classList.toggle('is-active', m.dataset.mediaIndex === i));
        $$('[data-thumb-index]', gallery).forEach((t) => t.classList.toggle('is-active', t === thumb));
      })
    );
  }

  /* ---------- Sticky mobile ATC ---------- */

  function bindStickyAtc() {
    const bar = $('[data-sticky-atc]');
    const buyRow = $('.pdp__buy-row');
    if (!bar || !buyRow) return;
    bar.hidden = false;
    const io = new IntersectionObserver(
      (entries) => bar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0),
      { threshold: 0 }
    );
    io.observe(buyRow);
  }

  /* ---------- Product recommendations ---------- */

  function bindRecommendations() {
    const holder = $('[data-recommendations]');
    if (!holder || !holder.dataset.url) return;
    fetch(holder.dataset.url)
      .then((r) => r.text())
      .then((html) => {
        const wrap = document.createElement('div');
        wrap.innerHTML = html;
        const fresh = $('[data-recommendations]', wrap);
        if (fresh && fresh.innerHTML.trim()) holder.innerHTML = fresh.innerHTML;
      })
      .catch(() => {});
  }

  /* ---------- Mobile nav ---------- */

  function closeMobileNav() {
    const nav = $('[data-mobile-nav]');
    const veil = $('[data-veil]');
    if (!nav) return;
    nav.classList.remove('is-open');
    if (veil) { veil.classList.remove('is-visible'); veil.hidden = true; }
    const burger = $('[data-menu-open]');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(() => { nav.hidden = true; }, 450);
  }

  function bindMobileNav() {
    const nav = $('[data-mobile-nav]');
    const burger = $('[data-menu-open]');
    const veil = $('[data-veil]');
    if (!nav || !burger) return;
    burger.addEventListener('click', () => {
      nav.hidden = false;
      requestAnimationFrame(() => {
        nav.classList.add('is-open');
        if (veil) { veil.hidden = false; requestAnimationFrame(() => veil.classList.add('is-visible')); }
      });
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
    const closeBtn = $('[data-menu-close]', nav);
    if (closeBtn) closeBtn.addEventListener('click', closeMobileNav);
    if (veil) veil.addEventListener('click', closeMobileNav);
  }

  /* ---------- Announcement rotator ---------- */

  function bindAnnouncement() {
    const bar = $('[data-announcement-rotator]');
    if (!bar) return;
    const items = $$('.announcement-bar__item', bar);
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4200);
  }

  /* ---------- Sticky header shadow ---------- */

  function bindHeader() {
    const header = $('[data-header]');
    if (!header) return;
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Horizontal scrollers (reviews) ---------- */

  function bindScrollers() {
    $$('[data-scroller]').forEach((scroller) => {
      const parent = scroller.parentElement;
      const step = () => scroller.firstElementChild ? scroller.firstElementChild.offsetWidth + 20 : 320;
      const prev = $('[data-scroll-prev]', parent);
      const next = $('[data-scroll-next]', parent);
      if (prev) prev.addEventListener('click', () => scroller.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => scroller.scrollBy({ left: step(), behavior: 'smooth' }));
    });
  }

  /* ---------- Reveal on scroll ---------- */

  function bindReveals() {
    const els = $$('.reveal');
    if (!els.length) return;
    const io = new IntersectionObserver(
      (entries) => entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      }),
      { rootMargin: '0px 0px -8% 0px' }
    );
    els.forEach((el) => io.observe(el));
  }

  /* ---------- Collection sort ---------- */

  function bindSort() {
    const select = $('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- Newsletter popup ---------- */

  const POPUP_KEY = 'avarae_popup_dismissed_at';

  function closePopup() {
    const popup = $('[data-popup]');
    if (!popup || !popup.classList.contains('is-open')) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    try { localStorage.setItem(POPUP_KEY, String(Date.now())); } catch (e) {}
  }

  function bindPopup() {
    const popup = $('[data-popup]');
    if (!popup) return;

    // Just subscribed: show the discount code immediately, apply it to the
    // session, and wire up the copy button.
    const success = $('[data-discount-success]', popup);
    if (success) {
      const code = success.dataset.discountCode;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      if (code) {
        fetch('/discount/' + encodeURIComponent(code)).catch(() => {});
        const copyBtn = $('[data-copy-code]', popup);
        if (copyBtn) {
          copyBtn.addEventListener('click', async () => {
            try {
              await navigator.clipboard.writeText(code);
              copyBtn.textContent = 'Kopyalandı ✓';
              setTimeout(() => { copyBtn.textContent = 'Kopyala'; }, 2500);
            } catch (e) {}
          });
        }
      }
      try { localStorage.setItem(POPUP_KEY, String(Date.now())); } catch (e) {}
      $$('[data-popup-close]', popup).forEach((el) => el.addEventListener('click', closePopup));
      return;
    }

    // Don't show again if recently dismissed
    const days = Number(popup.dataset.popupDays || 14);
    try {
      const last = Number(localStorage.getItem(POPUP_KEY) || 0);
      if (last && Date.now() - last < days * 864e5) return;
    } catch (e) {}

    let shown = false;
    const show = () => {
      if (shown) return;
      shown = true;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
    };

    setTimeout(show, Number(popup.dataset.popupDelay || 9) * 1000);
    document.addEventListener('mouseleave', (e) => { if (e.clientY <= 0) show(); });

    $$('[data-popup-close]', popup).forEach((el) => el.addEventListener('click', closePopup));
  }

  /* ---------- Init ---------- */

  document.addEventListener('DOMContentLoaded', () => {
    const drawer = $('[data-cart-drawer]');
    if (drawer) bindCartDrawer(drawer);
    bindProductForm();
    bindGallery();
    bindStickyAtc();
    bindRecommendations();
    bindMobileNav();
    bindAnnouncement();
    bindHeader();
    bindScrollers();
    bindReveals();
    bindSort();
    bindPopup();
  });
})();


// Gift wrap: persist as cart attribute
document.addEventListener('change', function (e) {
  if (!e.target.matches('[data-giftwrap]')) return;
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { 'Hediye Paketi': e.target.checked ? 'Evet' : '' } })
  });
});
